import React from "react";
import './style.css';

export function Loading(props: {isLoaded: boolean}) {
    return (
        <div className={`loading ${props.isLoaded ? 'loaded' : ''}`}>
            <Circle />
            <Circle />
            <Circle />
            <Circle />
            <Circle />
        </div>
    );
}

function Circle() {
    return (
        <div className="circle">
            <div className="inner"></div>
        </div>
    );
}